import React from 'react';
import { FieldInputProps } from 'react-final-form';

import styles from './RadioControl.scss';

type RadioControlPropsType = {
  disabled: boolean;
  displayText: string;
  id: string;
  inputProps: FieldInputProps<string, HTMLElement>;
}

export const RadioControl = ({ disabled, displayText, id, inputProps }: RadioControlPropsType) => (
  <div className={styles.radioControl}>
    <input required disabled={disabled} id={id} type='radio' {...inputProps}/>
    <label htmlFor={id}>{displayText}</label>
  </div>
);
